module.exports = __webpack_public_path__ + "img/homeplus.cd99d04f.png";